module.exports = __webpack_public_path__ + "img/Logo (1).44b9038c.svg";